module.exports = __webpack_public_path__ + "media/images/pr_detail/3-e73ca5d584d610c4ce11d4737a7e50ae.png";